import styled from "styled-components";

export const Container = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	align-items: flex-start;
	gap: 10px;

	@media (max-width: 426px) {
		grid-template-columns: 1fr;

		button {
			width: 100%;
			max-width: 100%;
			padding: 0.4rem 0 !important;
			margin: 0;
		}
	}
`;
